<template>
	<div>
		<ul class="list-unstyled">
			<li v-for="(attendee, index) in attendees" v-bind:key="index">
				<event-attendee :participant="attendee" :index="index"></event-attendee>
				<hr />
			</li>
		</ul>
		<div v-show="!maxParticipantsReached">
			<a href="#" v-on:click.prevent="addAttendee" class="btn btn-default">
				<i class="fa fa-plus-square"></i> {{ $t('event_registration.add_attendee') }}
			</a>
		</div>
	</div>
</template>

<script>
import EventAttendee from './EventAttendee';

export default {
	name: 'EventAttendees',

	components: {
		EventAttendee
	},

	props: {
		attendees: {
			type: Array,
			required: true
		}
	},

	mounted() {
		this.addAttendee();
	},

	computed: {
		maxParticipantsReached: function () {
			return this.attendees.length >= 5;
		}
	},

	methods: {
		addAttendee() {
			this.attendees.push({
				email: null,
				salutation_id: null,
				country_id: null,
				company_type_id: null,
				city: null,
				sector: null,
				first_name: null,
				last_name: null,
				company_name: null,
				company_website: null,
				companyDiffersFromFirstAttendee: false
			});

			Vue.nextTick(function () {
				window.$('.float-label-control').floatLabels();
			});
		}
	}
}
</script>

<style>
</style>
